import { useGetRenewVisaDocumentList } from "@/api/services/main/renew-visa";
import { RENEW_VISA_FILTER } from "@/features/renew-visa/constants/renewVisaFilter";
import { toNumber } from "@/utils/number";

type UseGetRenewVisaNotCreatedAndInProgressQuantityReturn = {
  quantity: number;
};
export const useGetRenewVisaNotCreatedAndInProgressQuantity = (): UseGetRenewVisaNotCreatedAndInProgressQuantityReturn => {
  const { data } = useGetRenewVisaDocumentList({
    status: RENEW_VISA_FILTER.NOT_CREATED_AND_IN_PROGRESS.status,
  });

  return {
    quantity: toNumber(data?.pagination.total),
  };
};
